import { useEffect } from 'react';
import { useBranding } from './branding-context';

export function ColorProvider({ children }: { children: React.ReactNode }) {
  const { primaryColor } = useBranding();

  useEffect(() => {
    // Calculate darker shade for hover
    const hexToRgb = (hex: string) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    };

    const darken = (hex: string, percent: number) => {
      const rgb = hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.max(0, Math.floor(rgb.r * (1 - percent)));
      const g = Math.max(0, Math.floor(rgb.g * (1 - percent)));
      const b = Math.max(0, Math.floor(rgb.b * (1 - percent)));

      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };

    const lighten = (hex: string, percent: number) => {
      const rgb = hexToRgb(hex);
      if (!rgb) return hex;

      const r = Math.min(255, Math.floor(rgb.r + (255 - rgb.r) * percent));
      const g = Math.min(255, Math.floor(rgb.g + (255 - rgb.g) * percent));
      const b = Math.min(255, Math.floor(rgb.b + (255 - rgb.b) * percent));

      return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };

    // Update CSS variables
    document.documentElement.style.setProperty('--primary-color', primaryColor);
    document.documentElement.style.setProperty('--primary-hover', darken(primaryColor, 0.2));
    document.documentElement.style.setProperty('--primary-light', lighten(primaryColor, 0.9));
  }, [primaryColor]);

  return <>{children}</>;
}
